var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tree-select',{attrs:{"dropdown-style":{ maxHeight: '400px', overflow: 'auto' },"tree-data":_vm.treeData,"placeholder":_vm.placeholder,"defaultValue":_vm.directoryId,"treeNodeLabelProp":"label"},on:{"select":_vm.selectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }